import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "../ui/dialog";
import { Maximize2 } from "lucide-react";

export const Zoomable = ({ src, alt, testid, className = "" }) => (
  <Dialog>
    <DialogTrigger asChild>
      <button type="button" data-testid={`${testid}-btn`} className={`group relative block w-full overflow-hidden bg-mm-sand ${className}`}>
        <img src={src} alt={alt} className="w-full h-auto group-hover:scale-[1.02] transition-transform duration-700" loading="lazy" />
        <span className="absolute bottom-4 right-4 inline-flex items-center gap-2 bg-mm-ink text-mm-paper px-4 py-2 text-sm font-bold">
          <Maximize2 className="w-4 h-4" /> Agrandir
        </span>
      </button>
    </DialogTrigger>
    <DialogContent className="max-w-[95vw] w-[1200px] p-2 bg-mm-paper rounded-none max-h-[95vh] overflow-auto" data-testid={`${testid}-dialog`}>
      <DialogTitle className="sr-only">{alt}</DialogTitle>
      <img src={src} alt={alt} className="w-full h-auto" />
    </DialogContent>
  </Dialog>
);

export const StatGrid = ({ items }) => (
  <div className="st grid sm:grid-cols-2 lg:grid-cols-4 gap-6 tab">
    {items.map((s) => (
      <div key={s.label} className={`border-t-4 pt-4 ${s.accent ? "border-mm-red" : "border-mm-ink"}`}>
        <p className="mm-lab text-mm-golddark">{s.label}</p>
        <p className={`disp text-3xl xl:text-4xl mt-2 ${s.accent ? "text-mm-red" : ""}`}>{s.big}</p>
        <p className="text-sm mt-2">{s.sub}</p>
      </div>
    ))}
  </div>
);

export const DataTable = ({ head, rows, testid }) => (
  <div className="overflow-x-auto" data-testid={testid}>
    <table className="w-full min-w-[520px] text-sm tab border-t-4 border-mm-ink">
      <thead><tr>{head.map((h) => <th key={h} className="mm-lab text-left py-3 pr-4 text-mm-golddark">{h}</th>)}</tr></thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r[0]} className="border-t border-mm-ink/20">
            {r.map((c, i) => <td key={`${r[0]}-${i}`} className={`py-3 pr-4 ${i === 0 ? "font-bold" : ""}`}>{c}</td>)}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const CardList = ({ items, cols = "md:grid-cols-2", numbered = true }) => (
  <ol className={`st grid ${cols} gap-x-8 gap-y-8`}>
    {items.map((r, i) => (
      <li key={r.t} className="border-t-2 border-mm-ink pt-4">
        <p className="disp text-xl">{numbered && <span className="text-mm-red mr-2">{i + 1}.</span>}{r.t}</p>
        <p className="text-sm mt-2 mm-body !text-[15px]">{r.d}</p>
      </li>
    ))}
  </ol>
);

export const SectionShell = ({ id, label, bg = "bg-mm-paper", innerRef, cls, children }) => (
  <section id={id} ref={innerRef} className={`${bg} text-mm-ink py-24 md:py-32 border-t border-mm-ink/10 ${cls}`} data-testid={`${id}-section`}>
    <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-[160px_1fr] gap-12">
      <p className="mm-lab text-mm-golddark">{label}</p>
      <div className="min-w-0 space-y-16">{children}</div>
    </div>
  </section>
);
